import { IComment } from "interfaces/comment";
import { useReadComments } from "hooks/comments/useReadComments";

interface Result {
  loading: boolean;
  getCaseActionComments: () => Promise<IComment[]>;
}

export function useReadCaseActionComments(actionId: number): Result {
  const { loading, getComments } = useReadComments(`case_actions/${actionId}`);

  return {
    loading,
    getCaseActionComments: getComments
  };
}
